import {cancelModalTimers, scheduleModal} from './modalState.js';

const removeBodyOverYHideIfNeeded = (item) => {
    if (
        !item.classList.contains('js-close--no-body-handle') &&
        !document.querySelector('.mob-die.active, .header.open, .modal.open')
    ) {
        document.body.classList.remove('over-y-hide');
    }
};

export const closeFunc = (e, item) => {
    e.preventDefault();

    const itemClose = item.closest('.item-close');
    const swiperTabsWrap = item.closest('.swiper-tabs-wrap');

    if (itemClose) {
        // if (!item.classList.contains('js-close--no-body-handle')) document.body.classList.remove('over-y-hide');

        if (!itemClose.classList.contains('modal')) {
            if (!itemClose.classList.contains('hint')) setTimeout(() => itemClose.classList.add('height'), 500);
            itemClose.classList.add('hidden');
            if (!itemClose.classList.contains('no-remove')) {
                setTimeout(() => {
                    itemClose.remove();
                    $('body').trigger('update:totalandprofit');
                    removeBodyOverYHideIfNeeded(item);
                }, 600);
            }
        } else {
            cancelModalTimers(itemClose);
            delete itemClose.dataset.modalOpening;
            itemClose.classList.remove('show');
            if (!itemClose.classList.contains('hint')) scheduleModal(itemClose, () => itemClose.classList.add('height'), 500);
            scheduleModal(itemClose, () => {
                    itemClose.classList.remove('open');
                    removeBodyOverYHideIfNeeded(item);
                }, 300);
            if (!itemClose.classList.contains('no-remove')) {
                scheduleModal(itemClose, () => {
                    itemClose.remove();
                    removeBodyOverYHideIfNeeded(item);
                }, 600);
            }
        }

        removeBodyOverYHideIfNeeded(item);

        if (swiperTabsWrap) {
            const swiperInstance = swiperTabsWrap.swiper;
            setTimeout(() => swiperInstance.updateAutoHeight(), 601);
        }
    }
};
